import type { Extension } from '@/types';

export type DatePreset = 'thisMonth' | 'lastMonth' | 'thisYear' | 'lastYear';

export function compareExtensions(a: Extension, b: Extension): number {
  return a.number.localeCompare(b.number, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}

function formatHtmlDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getDatePresetRange(preset: DatePreset): { startDate: string; endDate: string } {
  const today = new Date();
  let start: Date;
  let end = today;

  if (preset === 'lastMonth') {
    start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    end = new Date(today.getFullYear(), today.getMonth(), 0);
  } else if (preset === 'lastYear') {
    start = new Date(today.getFullYear() - 1, 0, 1);
    end = new Date(today.getFullYear() - 1, 11, 31);
  } else if (preset === 'thisYear') {
    start = new Date(today.getFullYear(), 0, 1);
  } else {
    start = new Date(today.getFullYear(), today.getMonth(), 1);
  }

  return {
    startDate: formatHtmlDate(start),
    endDate: formatHtmlDate(end),
  };
}
